import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {
  MeasuringBox,
  MeasuringBoxAlarmsQueryResponse,
  MeasuringBoxesQueryResponse,
  ProjectsQueryResponse
} from './_models'
import { TypeResponseSuccess } from '../../../../../pages/sensors/core/_models'

const API_URL = process.env.REACT_APP_API_URL

const getMeasuringBoxesFilter = (query: Record<string, any>): Promise<MeasuringBoxesQueryResponse> => {
  return axios
    .get(`${API_URL}/measuring-box/filter`, {params: query})
    .then((d: AxiosResponse<MeasuringBoxesQueryResponse>) => d.data)
}

const getMeasuringBoxAlarmsFilter = (query: Record<string, any>): Promise<MeasuringBoxAlarmsQueryResponse> => {
  return axios
    .get(`${API_URL}/measuring-box/filter`, {params: query})
    .then((d: AxiosResponse<MeasuringBoxAlarmsQueryResponse>) => d.data)
}

const createMeasuringBoxes = (measuring_box: MeasuringBox): Promise<MeasuringBox | undefined> => {
  return axios
    .post(`${API_URL}/measuring-box`, measuring_box)
    .then((response: AxiosResponse<Response<MeasuringBox>>) => response.data)
    .then((response: Response<MeasuringBox>) => response.data)
}

const updateMeasuringBoxes = (measuring_box: MeasuringBox): Promise<MeasuringBox | undefined> => {
  return axios
    .put(`${API_URL}/measuring-box/${measuring_box.id}`, measuring_box)
    .then((response: AxiosResponse<Response<MeasuringBox>>) => response.data)
    .then((response: Response<MeasuringBox>) => response.data)
}

const getAllProjects = (company_id: number): Promise<ProjectsQueryResponse> => {
  return axios.get(`${API_URL}/project/${company_id}`).then((d: AxiosResponse<ProjectsQueryResponse>) => d.data)
}

const getAllExportXls = (company_id: ID): Promise<MeasuringBox[]> => {
  return axios
    .get(`${API_URL}/measuring-box/${company_id}/export`)
    .then((d: AxiosResponse<MeasuringBox[]>) => d.data)
}

const turnPowerOn = (boxId: number): Promise<TypeResponseSuccess | undefined> => {
  return axios
    .post(`${API_URL}/log-box/nastek/turn-on-power/${boxId}`)
    .then((response: Response<TypeResponseSuccess>) => response.data)
}

const turnPowerOff = (boxId: number): Promise<TypeResponseSuccess | undefined> => {
  return axios
    .post(`${API_URL}/log-box/nastek/turn-off-power/${boxId}`)
    .then((response: Response<TypeResponseSuccess>) => response.data)
}

const requestOpenDoor = (boxId: number, challengeToken?: string): Promise<TypeResponseSuccess | undefined> => {
  const headers: Record<string, string> = {secret_key: 'X5VRrF&6(@!45dFN{xZ'}
  if (challengeToken) headers['X-2FA-Challenge'] = challengeToken
  return axios
    .post(`${API_URL}/log-box/nastek/open_door/${boxId}`, {}, {headers})
    .then((response: Response<TypeResponseSuccess>) => response.data)
}

// ===== 2FA =====

export type Channel2FA = 'email' | 'sms' | 'whatsapp'

export interface TwoFactorPreview {
  email: string | null
  phone: string | null
  has_email: boolean
  has_phone: boolean
}

export interface TwoFactorRequestResult {
  success: boolean
  destination: string
  channel: Channel2FA
  retry_after?: number
}

export interface TwoFactorVerifyResult {
  success: boolean
  challenge_token: string
  attempts_remaining?: number
}

const getTwoFactorPreview = (): Promise<TwoFactorPreview> => {
  return axios
    .get(`${API_URL}/users/me/2fa-preview`)
    .then((r: AxiosResponse<TwoFactorPreview>) => r.data)
}

const requestTwoFactorCode = (measuring_box_id: number, channel: Channel2FA): Promise<TwoFactorRequestResult> => {
  return axios
    .post(`${API_URL}/2fa/request`, {measuring_box_id, channel})
    .then((r: AxiosResponse<TwoFactorRequestResult>) => r.data)
}

const verifyTwoFactorCode = (measuring_box_id: number, code: string): Promise<TwoFactorVerifyResult> => {
  return axios
    .post(`${API_URL}/2fa/verify`, {measuring_box_id, code})
    .then((r: AxiosResponse<TwoFactorVerifyResult>) => r.data)
}

export {
  getMeasuringBoxesFilter,
  getMeasuringBoxAlarmsFilter,
  createMeasuringBoxes,
  updateMeasuringBoxes,
  getAllProjects,
  getAllExportXls,
  turnPowerOn,
  turnPowerOff,
  requestOpenDoor,
  getTwoFactorPreview,
  requestTwoFactorCode,
  verifyTwoFactorCode,
}
